

























import { Component, Vue, Prop } from 'vue-property-decorator'
import { LoginUser, Occupation } from '@/types/user'

@Component
export default class VideoCallIncoming extends Vue {
  @Prop(Object) caller!: LoginUser
  @Prop(Object) occupation!: Occupation

  get caption() {
    console.log(this.caller)
    const occupation =
      !this.caller.isPatient && !this.caller.isWorker
        ? '家族'
        : this.caller.isPatient
        ? '患者'
        : this.occupation.name
    return `${this.caller.lastName}${this.caller.firstName}（${occupation}）`
  }

  handleAcceptVideo() {
    this.$emit('acceptVideo')
  }

  handleAcceptOnlyMicrophone() {
    this.$emit('acceptOnlyMicrophone')
  }

  handleDeny() {
    this.$emit('deny')
  }
}
